<template>
  <div id="app" :style="{ backgroundColor: visualSettings.bodyBackgroundColor }">
    <Chat />
    <notifications class="app-notifications" group="app" classes="notification-style"  />
  </div>
</template>

<script>
import Chat from '@/components/Chat';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'App',
  components: {
    Chat
  },
  computed: {
    ...mapGetters([
      'visualSettings'
    ])
  },
  methods: {
    ...mapMutations([
      'setHashVisualSettings'
    ])
  },
  mounted() {
    window.addEventListener('hashchange', () => {
      this.setHashVisualSettings();
    });
    this.setHashVisualSettings();
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  background: #fff;
}

#app {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(47, 49, 56);
  height: 100%;
  width: 100%;
  overflow: hidden;
  scrollbar-color: rgba(47, 49, 56, 0.6) rgba(0,0,0,0);
}

::-webkit-scrollbar {
  width: 14px;
}

::-webkit-scrollbar-track {
  border-radius: 7px;
  background: rgba(255,255,255,0);
}

::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background: rgba(47, 49, 56, 0.6);
  border: 3px solid #fff;
}

::-webkit-scrollbar-button {
  display: none;
}

a {
  color: #31a0e8;
  transition: opacity 250ms ease-out;

  &:hover {
    opacity: 0.7;
  } 
}

.app-notifications {
  top: 16px;
  right: 16px;
}

.notification-style {
  padding: 16px;
  font-size: 13.6px;
  line-height: 1.35;
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(60, 40, 40, 0.12);
  border-left: 0;
  margin: 16px 16px 0 0;

  .notification-content {
    margin-top: 4px;
  }

  &.error {
    color: #fff;
    background: #E54D42;
  }

  &.success {
    color: #fff;
    background: #2bbd7e;
  }
}

.vm--modal {
  font-size: 13.6px;
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(60, 40, 40, 0.12);
  max-height: calc(100% - 40px);
  overflow: visible;
}
</style>
